import { authenticationTypes, userGroups } from 'root/src/shared/constants/auth';
import { pointsEndpointIds } from 'root/src/shared/points/points.constants';
export const listCampaignTermsAcceptedEndpoint = {
    [pointsEndpointIds.LIST_CAMPAIGN_TERMS_ACCEPTED]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: userGroups.admin,
        payloadSchema: {
            type: 'object',
            properties: {
                dropId: { type: 'string' },
            },
        },
        required: ['dropId'],
    },
};
